export const useLoaderState = () => useState('armani_loader_state', () => false)

export const useLoaderOpacity = () =>
  useState('armani_loader_style', () => false)
